import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "mc",
  style: {"padding":"35px 50px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "fs20 ls1 mc centered fw600" }, "お問い合わせ・ご要望", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fs12" }, "満足度を入力してください。", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "centered" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "fs14 whiteColor fw600"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/star_null.png`),
            width: "40",
            class: "fl satiStar star1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rate(1)))
          }, null, 8, _hoisted_8),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/star_null.png`),
            width: "40",
            class: "fl satiStar star2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rate(2)))
          }, null, 8, _hoisted_9),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/star_null.png`),
            width: "40",
            class: "fl satiStar star3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rate(3)))
          }, null, 8, _hoisted_10),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/star_null.png`),
            width: "40",
            class: "fl satiStar star4",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rate(4)))
          }, null, 8, _hoisted_11),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/star_null.png`),
            width: "40",
            class: "fl satiStar star5",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rate(5)))
          }, null, 8, _hoisted_12)
        ]),
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _createVNode(_component_TextareaTag, {
          placeholder: "満足度の理由とご要望などを入力",
          style: {"height":"130px"},
          class: "fl fs14 roundForm mw100",
          onInputValue: _ctx.inputContent
        }, null, 8, ["onInputValue"]),
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("section", {
          class: "pointer centered circle_button skyblueBg fs16 mc",
          style: {"width":"220px","border-radius":"8px","height":"44px","padding":"9px 8px","margin-left":"140px"},
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendInquiry && _ctx.sendInquiry(...args)))
        }, [
          (!this.isSmartPhone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "  送信"))
            : _createCommentVNode("", true)
        ]),
        _hoisted_21
      ])
    ])
  ]))
}